import type {
  FirstLoginPasswordBody,
  ForgotPasswordBody,
  GetMeResponse,
  LoginBody,
  LoginResponse,
  RefreshResponse,
  ResetPasswordBody,
  SwitchTenantBody,
  SwitchTenantResponse,
} from '@movo/contracts/api/auth';
import type { GetMyTenantsResponse } from '@movo/contracts/api/tenants';
import apiClient from '@/shared/lib/apiClient';

export type MyTenant = GetMyTenantsResponse['data']['items'][number];

/** `{ token, user, mustChangePassword }`. */
export async function login(credentials: LoginBody) {
  const { data } = await apiClient.post<LoginResponse>('/auth/login', credentials);
  return data;
}

export async function logout() {
  await apiClient.post('/auth/logout', {}, { _skipAuthRefresh: true });
}

/** Un nuovo access token dal cookie di refresh. */
export async function refresh() {
  const { data } = await apiClient.post<RefreshResponse>(
    '/auth/refresh',
    {},
    { _skipAuthRefresh: true }
  );
  return data.token;
}

export async function fetchMe() {
  const { data } = await apiClient.get<GetMeResponse>('/auth/me');
  return data.user;
}

export async function forgotPassword(email: ForgotPasswordBody['email']) {
  await apiClient.post('/auth/forgot-password', { email } satisfies ForgotPasswordBody);
}

export async function resetPassword(body: ResetPasswordBody) {
  await apiClient.post('/auth/reset-password', body);
}

export async function changeFirstLoginPassword(newPassword: FirstLoginPasswordBody['newPassword']) {
  await apiClient.put('/auth/first-login-password', {
    newPassword,
  } satisfies FirstLoginPasswordBody);
}

/** Il token con il nuovo tenant attivo. */
export async function switchTenant(tenantId: SwitchTenantBody['tenantId']) {
  const { data } = await apiClient.post<SwitchTenantResponse>('/auth/switch-tenant', {
    tenantId,
  } satisfies SwitchTenantBody);
  return data.token;
}

/** I tenant a cui l'utente può accedere. */
export async function fetchMyTenants() {
  const { data } = await apiClient.get<GetMyTenantsResponse>('/tenants/me');
  return data.data.items;
}
